import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Injectable, Post } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getConnection, In, Like, MoreThan, Not, Raw, Repository } from 'typeorm';
import { AppSettingEntity } from '../post/app-settings.entity';
import { WhatsappGroupsEntity } from './whatsappgrp.entity';
import { AllSettingsResponseModel, SingleResponseModel } from './dto/whatsapp-response-model';
import { GrpStatuUpdateDto, MsgDTO, WhatsAppSetngDto } from './dto/whatsapp.dto';
import { sendWhatsAppImgMSG, sendWhatsAppTxtMSG, sendWhatsAppVideoMSG } from '../shared/mobileOTP';
import * as request from 'request';
import { OtherMsgEntity } from './msgcnt.entity';
@Injectable()
export class WhatsappService {
    constructor (
        @InjectRepository(AppSettingEntity)
        private AppsetRepo: Repository<AppSettingEntity>, 

        @InjectRepository(WhatsappGroupsEntity)
        private whtGrpRepo: Repository<WhatsappGroupsEntity>,

        @InjectRepository(OtherMsgEntity)
        private OthrMsgRepo: Repository<OtherMsgEntity>,

    ) {}

    async sendWhatsAppImg(img,cap,txt,to,mob) {
        const data = await this.AppsetRepo.findOne({
            where: {type:'Whatsapp',mobilenumber:mob},
        });
        var wkey = data && data.wupkey != undefined ? data.wupkey : '';
        var winst = data && data.wupinstnce != undefined ? data.wupinstnce : '';
        return await sendWhatsAppImgMSG(img,cap,txt,to,wkey,winst)
        .then(() => {      
          console.log('msg sent successufully'+img);
          return true;
        })
        .catch((err) => {
          console.log('error in sending msg ', err);
          return false;
        });
    }

    async sendWhatsAppTxt(txt,to,mob) {
        const data = await this.AppsetRepo.findOne({
            where: {type:'Whatsapp',mobilenumber:mob},
        });
        var wkey = data && data.wupkey != undefined ? data.wupkey : '';
        var winst = data && data.wupinstnce != undefined ? data.wupinstnce : '';
        return await sendWhatsAppTxtMSG(txt,to,wkey,winst)
        .then(() => {      
          console.log('msg sent successufully');
          return true;
        })
        .catch((err) => {
          console.log('error in sending msg ', err);
          return false;
        });
    }

    async sendWhatsAppVideo(img,cap,txt,to,mob) {
        const data = await this.AppsetRepo.findOne({
            where: {type:'Whatsapp',mobilenumber:mob},
        });
        var wkey = data && data.wupkey != undefined ? data.wupkey : '';
        var winst = data && data.wupinstnce != undefined ? data.wupinstnce : '';
        return await sendWhatsAppVideoMSG(img,cap,txt,to,wkey,winst)
        .then(() => {      
          console.log('msg sent successufully'+img);
          return true;
        })
        .catch((err) => {
          console.log('error in sending msg ', err);
          return false;
        });
    }

    async getAppSettings(queryParams,request:Request):Promise<AllSettingsResponseModel> {
        const response = new AllSettingsResponseModel();
        try {
            const finalData: any[] = [];
            if(queryParams.apiVersion == 1) {
                const data = await this.AppsetRepo.find({
                    order: { Id: 'ASC' }
                });
                if(!data) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const final = data.map(b => {
                    return {
                        Id: b.Id,
                        Type:b.type,
                        Status: b.status == 0 ? false : true
                    }   
                });   
                response.status = true;
                response.data = final;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;              
            }  else {
                const data = await this.AppsetRepo.find({
                    order: { Id: 'ASC' }
                });
                if(!data) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const final = data.map(b => {
                    return {
                        Id: b.Id,
                        Type:b.type,
                        Status: b.status == 0 ? false : true
                    }   
                });   
                response.status = true;
                response.data = final;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;                 
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async changeAppSettings(queryParams, waDto:WhatsAppSetngDto,request:Request): Promise<SingleResponseModel> {
        const response = new SingleResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const updatedData = await this.AppsetRepo.update(waDto.Id,waDto);
                const data = await this.AppsetRepo.findOne({
                    where: {Id:waDto.Id},
                });
                if(!updatedData) {
                    throw new ErrorResponse(99908,'Settings update failed')
                }                 
                response.status = true;
                response.statusCode = 50000;
                response.internalMessage = 'Settings updated';
                response.intlCode = 11108;
                response.data = data;
            } else  {
                const updatedData = await this.AppsetRepo.update(waDto.Id,waDto);
                const data = await this.AppsetRepo.findOne({
                    where: {Id:waDto.Id},
                });
                if(!updatedData) {
                    throw new ErrorResponse(99908,'Settings update failed')
                }                 
                response.status = true;
                response.statusCode = 50000;
                response.internalMessage = 'Settings updated';
                response.intlCode = 11108;
                response.data = data;
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async saveWhatsAppGroupsFromAPP(queryParams,request1:Request):Promise<AllSettingsResponseModel> {
        const response = new AllSettingsResponseModel();
        try {
            const finalData: any[] = [];
            let currDt = new Date().toJSON().slice(0, 10);
            const data = await this.AppsetRepo.findOne({
                where: {type:'Whatsapp',status:1},
            });
            var wkey = data && data.wupkey != undefined ? data.wupkey : '';
            var winst = data && data.wupinstnce != undefined ? data.wupinstnce : '';
            var options = {
                method: 'GET',
                  url: `https://api.ultramsg.com/${winst}/groups`,
                  headers: {'content-type': 'application/x-www-form-urlencoded'},
                qs: {
                    token: `${wkey}`
                }
            };
            if(queryParams.apiVersion == 1) {    
                const idsary = [];
                const reslt = await new Promise<any[]>((resolve, reject) => {
                    request(options, (error, response, body) => {
                        if (error) {
                            return reject(error);
                        }

                        return resolve(JSON.parse(body));
                    });
                });
               console.log('rslts'+reslt);
               console.log(typeof reslt);
            
                //var kres = await reslt;

               // let array = JSON.parse(reslt);
             
               // reslt.then((kres) => {
               // reslt.forEach(async function(o) {
                for(const o of reslt ) {
                        console.log('res'+o.id);
                         var ext = await this.whtGrpRepo.findOne({
                            where:{groupId:o.id}
                        });
                        console.log('ext'+ext);
                        if(ext) {
                            console.log('updt');
                            let info = {
                                groupName:o.name,
                                updatedUser:1,
                                versionFlag:1
                            }
                            await this.whtGrpRepo.update({groupId:o.id},info);                                
                        } else {
                            console.log('save');
                            let k = await this.whtGrpRepo.save({
                                groupId:o.id,
                                groupName:o.name,
                                status:0,
                                createdUser:1,
                                versionFlag:1,
                                createdAt: currDt
                            });
                            console.log('save aftr'+k);
                        } 
                    }
                //);
               // })

               
                response.status = true;
                response.statusCode = 50000;
                response.internalMessage = 'Groups Saved Successfully';
                response.intlCode = 11100;
            }  else {    
                const idsary = [];
                const reslt = await new Promise<any[]>((resolve, reject) => {
                    request(options, (error, response, body) => {
                        if (error) {
                            return reject(error);
                        }

                        return resolve(JSON.parse(body));
                    });
                });
               console.log('rslts'+reslt);
               console.log(typeof reslt);
            
                //var kres = await reslt;

               // let array = JSON.parse(reslt);
             
               // reslt.then((kres) => {
               // reslt.forEach(async function(o) {
                for(const o of reslt ) {
                        console.log('res'+o.id);
                         var ext = await this.whtGrpRepo.findOne({
                            where:{groupId:o.id}
                        });
                        console.log('ext'+ext);
                        if(ext) {
                            console.log('updt');
                            let info = {
                                groupName:o.name,
                                updatedUser:1,
                                versionFlag:1
                            }
                            await this.whtGrpRepo.update({groupId:o.id},info);                                
                        } else {
                            console.log('save');
                            let k = await this.whtGrpRepo.save({
                                groupId:o.id,
                                groupName:o.name,
                                status:0,
                                createdUser:1,
                                versionFlag:1,
                                createdAt: currDt
                            });
                            console.log('save aftr'+k);
                        } 
                    }
                //);
               // })

               
                response.status = true;
                response.statusCode = 50000;
                response.internalMessage = 'Groups Saved Successfully';
                response.intlCode = 11100;
            }
            return response;
        } catch (error) {
            throw error;
        }
    }


    async getWhatsAppGroups(queryParams,request:Request):Promise<AllSettingsResponseModel> {
        const response = new AllSettingsResponseModel();
        try {
            const finalData: any[] = [];
            if(queryParams.apiVersion == 1) {
                const data = await this.whtGrpRepo.find({
                    order: { Id: 'ASC' }
                });
                if(!data) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const final = data.map(b => {
                    return {
                        Id: b.Id,
                        groupId: b.groupId,
                        groupName: b.groupName,
                        Status: b.status == 0 ? false : true
                    }   
                });   
                response.status = true;
                response.data = final;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;              
            }  else {
                const data = await this.whtGrpRepo.find({
                    order: { Id: 'ASC' }
                });
                if(!data) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const final = data.map(b => {
                    return {
                        Id: b.Id,
                        groupId: b.groupId,
                        groupName: b.groupName,
                        Status: b.status == 0 ? false : true
                    }   
                });   
                response.status = true;
                response.data = final;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;                  
            }
            return response;
        } catch (error) {
            throw error;
        }
    }


    async changeWhatsAppGroupsStatus(queryParams, waDto:GrpStatuUpdateDto,request:Request): Promise<SingleResponseModel> {
        const response = new SingleResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const updatedData = await this.whtGrpRepo.update(waDto.Id,waDto);
                const data = await this.whtGrpRepo.findOne({
                    where: {Id:waDto.Id},
                });
                if(!updatedData) {
                    throw new ErrorResponse(99908,'Group Status update failed')
                }                 
                response.status = true;
                response.statusCode = 50000;
                response.internalMessage = 'Group Status updated';
                response.intlCode = 11108;
                response.data = data;
            } else  {
                const updatedData = await this.whtGrpRepo.update(waDto.Id,waDto);
                const data = await this.whtGrpRepo.findOne({
                    where: {Id:waDto.Id},
                });
                if(!updatedData) {
                    throw new ErrorResponse(99908,'Group Status update failed')
                }                 
                response.status = true;
                response.statusCode = 50000;
                response.internalMessage = 'Group Status updated';
                response.intlCode = 11108;
                response.data = data;
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async sendtxtmsg(queryParams,postDto:MsgDTO,request:Request): Promise<SingleResponseModel> {
        const response = new SingleResponseModel();
        try {  
            let andurl = '';
            let iosurl = '';
            const configdt = await this.AppsetRepo.findOne({
                where:{type:'Config'},
                order: { Id: 'ASC' }
            }); 

            if(configdt) {
                if(configdt.android != null && configdt.android != '')
                    andurl = configdt.android;
                
                if(configdt.ios != null && configdt.ios != '')
                    iosurl = configdt.ios;
            }

           
            if(queryParams.apiVersion == 1) {
               
                let currDt = new Date().toJSON().slice(0, 10);
    
                const postdumrec = await this.OthrMsgRepo.findOne({
                    where:{insDate: currDt},
                    order:{createdAt: "DESC"}
                });

                let mobary = postDto.mobilenums.split(',');
                if(postdumrec) {
                    if(postdumrec.remains < 500 && mobary.length > 0) {
                        postdumrec.remains -= mobary.length;
                        postdumrec.sent += mobary.length; 
                        await this.OthrMsgRepo.update(postdumrec.Id,{
                            sent: postdumrec.sent,
                            remains: postdumrec.remains
                        });
                        var mob = mobary.toString();
                        var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                        var txt = postDto.text ;
                        var to = mob;
                        this.sendWhatsAppTxt(txt,to,postDto.mobileno);
                    } else {
                        throw new ErrorResponse(11106, 'Messages limit exceeded')
                    }  
                } else {
                    let remin = 500 - mobary.length;
                    await this.OthrMsgRepo.save({
                        sent: mobary.length,
                        remains: remin,
                        insDate: currDt
                    });                                
                    var mob = mobary.toString();
                    var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                    var txt = postDto.text ;
                    var to = mob;
                    this.sendWhatsAppTxt(txt,to,postDto.mobileno);                     
                }  
                response.status = true;
                response.statusCode = 50000;
                response.internalMessage = 'Message Sent Successfully';
                response.intlCode = 11100;             
            } else {
               
                let currDt = new Date().toJSON().slice(0, 10);
    
                const postdumrec = await this.OthrMsgRepo.findOne({
                    where:{insDate: currDt},
                    order:{createdAt: "DESC"}
                });

                let mobary = postDto.mobilenums.split(',');
                if(postdumrec) {
                    if(postdumrec.remains < 500 && mobary.length > 0) {
                        postdumrec.remains -= mobary.length;
                        postdumrec.sent += mobary.length; 
                        await this.OthrMsgRepo.update(postdumrec.Id,{
                            sent: postdumrec.sent,
                            remains: postdumrec.remains
                        });
                        var mob = mobary.toString();
                        var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                        var txt = postDto.text ;
                        var to = mob;
                        this.sendWhatsAppTxt(txt,to,postDto.mobileno);
                    } else {
                        throw new ErrorResponse(11106, 'Messages limit exceeded')
                    }  
                } else {
                    let remin = 500 - mobary.length;
                    await this.OthrMsgRepo.save({
                        sent: mobary.length,
                        remains: remin,
                        insDate: currDt
                    });                                
                    var mob = mobary.toString();
                    var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                    var txt = postDto.text ;
                    var to = mob;
                    this.sendWhatsAppTxt(txt,to,postDto.mobileno);                     
                }  
                response.status = true;
                response.statusCode = 50000;
                response.internalMessage = 'Message Sent Successfully';
                response.intlCode = 11100;             
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async sendimgvidmsg(queryParams,imgpath,postDto:MsgDTO): Promise<SingleResponseModel> {
        const response = new SingleResponseModel();
        try {   
            let andurl = '';
            let iosurl = '';
            const configdt = await this.AppsetRepo.findOne({
                where:{type:'Config'},
                order: { Id: 'ASC' }
            }); 

            if(configdt) {
                if(configdt.android != null && configdt.android != '')
                    andurl = configdt.android;
                
                if(configdt.ios != null && configdt.ios != '')
                    iosurl = configdt.ios;
            }        
           
            if(queryParams.apiVersion == 1) {
               
                let currDt = new Date().toJSON().slice(0, 10);
    
                const postdumrec = await this.OthrMsgRepo.findOne({
                    where:{insDate: currDt},
                    order:{createdAt: "DESC"}
                });

                let mobary = postDto.mobilenums.split(',');
                if(postdumrec) {
                    if(postdumrec.remains < 500 && mobary.length > 0) {
                        postdumrec.remains -= mobary.length;
                        postdumrec.sent += mobary.length; 
                        await this.OthrMsgRepo.update(postdumrec.Id,{
                            sent: postdumrec.sent,
                            remains: postdumrec.remains
                        });
                        var mob = mobary.toString();
                        if(postDto.TypeId == 2) {
                            var img = `${process.env.WORKINGURL}/${imgpath}`;
                            var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                            var cap = postDto.text;
                            var txt = '';
                            var to = mob;
                            this.sendWhatsAppImg(img,cap,txt,to,postDto.mobileno);
                        } else if(postDto.TypeId == 3) {
                            var img = `${process.env.WORKINGURL}/${imgpath}`;
                            var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                            var cap = postDto.text;
                            var txt = '';
                            var to = mob;
                            this.sendWhatsAppVideo(img,cap,txt,to,postDto.mobileno);
                        }  
                                             
                    } else {
                        throw new ErrorResponse(11106, 'Messages limit exceeded')
                    } 
                } else {
                    let remin = 500 - mobary.length;
                    await this.OthrMsgRepo.save({
                        sent: mobary.length,
                        remains: remin,
                        insDate: currDt
                    });                                
                    var mob = mobary.toString();
                    if(postDto.TypeId == 2) {
                        var img = `${process.env.WORKINGURL}/${imgpath}`;
                        var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                        var cap = postDto.text;
                        var txt = '';
                        var to = mob;
                        this.sendWhatsAppImg(img,cap,txt,to,postDto.mobileno);
                    } else if(postDto.TypeId == 3) {
                        var img = `${process.env.WORKINGURL}/${imgpath}`;
                        var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                        var cap = postDto.text;
                        var txt = '';
                        var to = mob;
                        this.sendWhatsAppVideo(img,cap,txt,to,postDto.mobileno);
                    }  
                                       
                }  
                response.status = true;
                response.statusCode = 50000;
                response.internalMessage = 'Message Sent Successfully';
                response.intlCode = 11100;            
            } else {
               
                let currDt = new Date().toJSON().slice(0, 10);
    
                const postdumrec = await this.OthrMsgRepo.findOne({
                    where:{insDate: currDt},
                    order:{createdAt: "DESC"}
                });

                let mobary = postDto.mobilenums.split(',');
                if(postdumrec) {
                    if(postdumrec.remains < 500 && mobary.length > 0) {
                        postdumrec.remains -= mobary.length;
                        postdumrec.sent += mobary.length; 
                        await this.OthrMsgRepo.update(postdumrec.Id,{
                            sent: postdumrec.sent,
                            remains: postdumrec.remains
                        });
                        var mob = mobary.toString();
                        if(postDto.TypeId == 2) {
                            var img = `${process.env.WORKINGURL}/${imgpath}`;
                            var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                            var cap = postDto.text;
                            var txt = '';
                            var to = mob;
                            this.sendWhatsAppImg(img,cap,txt,to,postDto.mobileno);
                        } else if(postDto.TypeId == 3) {
                            var img = `${process.env.WORKINGURL}/${imgpath}`;
                            var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                            var cap = postDto.text;
                            var txt = '';
                            var to = mob;
                            this.sendWhatsAppVideo(img,cap,txt,to,postDto.mobileno);
                        }                      
                    } else {
                        throw new ErrorResponse(11106, 'Messages limit exceeded')
                    } 
                } else {
                    let remin = 500 - mobary.length;
                    await this.OthrMsgRepo.save({
                        sent: mobary.length,
                        remains: remin,
                        insDate: currDt
                    });                                
                    var mob = mobary.toString();
                    if(postDto.TypeId == 2) {
                        var img = `${process.env.WORKINGURL}/${imgpath}`;
                        var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                        var cap = postDto.text;
                        var txt = '';
                        var to = mob;
                        this.sendWhatsAppImg(img,cap,txt,to,postDto.mobileno);
                    } else if(postDto.TypeId == 3) {
                        var img = `${process.env.WORKINGURL}/${imgpath}`;
                        var dwlnk = `Download netR App and connect with your Politician at Android users : ${andurl} and IOS users : ${iosurl}`;               
                        var cap = postDto.text;
                        var txt = '';
                        var to = mob;
                        this.sendWhatsAppVideo(img,cap,txt,to,postDto.mobileno);
                    }  
                                        
                }  
                response.status = true;
                response.statusCode = 50000;
                response.internalMessage = 'Message Sent Successfully';
                response.intlCode = 11100;           
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async getWhatsAppMobileNos(queryParams,request:Request):Promise<AllSettingsResponseModel> {
        const response = new AllSettingsResponseModel();
        try {
            const finalData: any[] = [];
            if(queryParams.apiVersion == 1) {
                const data = await this.AppsetRepo.find({
                    where:{type:'Whatsapp'},
                    order: { Id: 'ASC' }
                });
                if(!data) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const final = data.map(b => {
                    return {
                        Id: b.Id,
                        Type:b.type,
                        MobileNo:b.mobilenumber,
                        Status: b.status == 0 ? false : true
                    }   
                });   
                response.status = true;
                response.data = final;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;              
            }  else {
                const data = await this.AppsetRepo.find({
                    where:{type:'Whatsapp'},
                    order: { Id: 'ASC' }
                });
                if(!data) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const final = data.map(b => {
                    return {
                        Id: b.Id,
                        Type:b.type,
                        MobileNo:b.mobilenumber,
                        Status: b.status == 0 ? false : true
                    }   
                });   
                response.status = true;
                response.data = final;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;                 
            }
            return response;
        } catch (error) {
            throw error;
        }
    }
}